import { render, staticRenderFns } from "./IpTk.vue?vue&type=template&id=b96c6028"
import script from "./IpTk.vue?vue&type=script&lang=js"
export * from "./IpTk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports